<template lang="html">
  <div class="Feature">
    <div class="overview">
      <div class="title overview__title">
        <h3>会社概要</h3>
      </div>
      <div class="content overview__content">
        <p>
          {{ investorInfo.overview }}
        </p>
      </div>
    </div>
    <div class="pointer">
      <div class="title pointer__title">
        <h3>強み/アピールポイント</h3>
      </div>
      <div class="content pointer__content">
        <p>
          {{ investorInfo.point }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'investorPolicy',
  props: ['investorInfo']
}
</script>

<style lang="scss" scoped>
@import '@/scss/base.scss';
@import '@/scss/components/utility.scss';
.Feature {
  padding: 2rem 2.5rem;
  // margin-top: 1.7rem;
  border: 1px solid #d2d2d2;
  border-radius: 3px;
  width: 100%;
  @include respondIn(lg) {
    width: 95%;
    margin-left: auto;
    margin-right: auto;
    padding: 2rem 0;
  }
  @include respondIn(md) {
    width: 100%;
    padding: 2rem 20px;
  }
}
.overview {
  padding: 1rem 0;
  border-bottom: 1px solid #d2d2d2;
  margin-bottom: 1.5rem;
  @include respondIn(lg) {
    padding: 1rem 20px;
  }
  @include respondIn(md) {
    padding: 20px;
  }
}
.pointer {
  padding: 1rem 0;
  @include respondIn(lg) {
    padding: 1rem 20px;
  }
  @include respondIn(md) {
    padding: 20px;
  }
}
.title {
  margin-bottom: 1rem;
}
.content p {
  word-wrap: break-word;
}
</style>
